import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { API } from '../../../../api/URL_API';
import { Link } from 'react-router-dom';
import '../../styles/CategoriasUni.css';
import { ArrowDownCircleFill } from 'react-bootstrap-icons';

function CategoriasUni({ idSucursal }) {
    const [data, setData] = useState([]);

    // ✅ Función para determinar el estado inicial del acordeón
    const getInitialExpandedState = () => {
        const lastInteraction = localStorage.getItem("lastCategoryInteraction");
        const expandedSection = localStorage.getItem("expandedSection");

        // Si no hay interacción previa, mantener cerrado
        if (!lastInteraction) {
            return false; // Cerrado por defecto
        }

        const timeSinceLastInteraction = Date.now() - parseInt(lastInteraction, 10);
        const thirtyMinutes = 5 * 60 * 1000; // 30 minutos en milisegundos

        // Si han pasado más de 30 minutos, cerrar el acordeón y limpiar datos
        if (timeSinceLastInteraction > thirtyMinutes) {
            localStorage.removeItem("expandedSection");
            localStorage.removeItem("scrollPosition");
            localStorage.removeItem("lastCategoryInteraction");
            return false; // Cerrado después de inactividad
        }

        // Si la interacción fue reciente, mantener la sección expandida
        return expandedSection || false;
    };

    const [expanded, setExpanded] = useState(getInitialExpandedState());

    // ✅ Función para detectar si una sección tiene categorías nuevas
    const sectionHasNewCategories = (seccion) => {
        if (!seccion.categorias || seccion.categorias.length === 0) {
            return false;
        }

        const threeDaysAgo = new Date();
        threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);

        return seccion.categorias.some(categoria => {
            try {
                const lastUpdated = new Date(categoria.lastUpdated);
                return lastUpdated >= threeDaysAgo;
            } catch (error) {
                console.log("Error procesando fecha de categoría:", categoria.nomCategoria, error);
                return false;
            }
        });
    };

    // ✅ Restaurar el scroll después de que se cargue el contenido
    useEffect(() => {
        const savedScrollPosition = localStorage.getItem("scrollPosition");

        // Cargar datos de la API
        fetch(`${API}/api/mostrarCategorias/categorias`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setData(data);

                // ✅ Asegurarse de restaurar el scroll **después** de que los datos se carguen
                setTimeout(() => {
                    if (savedScrollPosition) {
                        window.scrollTo(0, parseInt(savedScrollPosition, 10));
                    }
                }, 100); // Pequeño retraso para garantizar que React haya renderizado todo
            })
            .catch((error) => {
                console.error('Error al cargar secciones y categorías:', error);
            });
    }, []);

    // ✅ Manejar la expansión/colapso del acordeón
    const handleAccordionChange = (panelIndex) => {
        const currentTime = Date.now();

        if (expanded === panelIndex) {
            // Si el panel ya está abierto, cerrarlo
            setExpanded(false);
            localStorage.removeItem("expandedSection");
            localStorage.removeItem("scrollPosition");
            localStorage.removeItem("lastCategoryInteraction");
        } else {
            // Si el panel está cerrado, abrirlo
            localStorage.setItem("scrollPosition", window.scrollY);
            localStorage.setItem("expandedSection", panelIndex);
            localStorage.setItem("lastCategoryInteraction", currentTime.toString());
            setExpanded(panelIndex);
        }
    };

    // ✅ Guardar la posición del scroll antes de navegar a una categoría
    const handleCategoryClick = (panelIndex) => {
        const currentTime = Date.now();
        localStorage.setItem("scrollPosition", window.scrollY);
        localStorage.setItem("expandedSection", panelIndex);
        localStorage.setItem("lastCategoryInteraction", currentTime.toString());
    };

    return (
        <div className="py-4">
            <div className='text-center mb-4'>
                <h2 className='fw-bold text-black fs-1'>CATALOGO</h2>
                <span className='text-muted'>Precios mayoristas luego de 8 unidades</span>
            </div>
            <Container fluid>
                {data.map((seccion, index) => {
                    const hasNewCategories = sectionHasNewCategories(seccion);

                    return (
                        <Accordion
                            key={seccion.nomSeccion}
                            sx={{ backgroundColor: 'black', color: 'white', marginBottom: '10px', borderRadius: '8px' }}
                            expanded={expanded === `panel${index}`}
                            onChange={() => handleAccordionChange(`panel${index}`)}
                        >
                            <AccordionSummary expandIcon={<ArrowDownCircleFill className='text-white' />}>
                                <div className="d-flex align-items-cente">
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: 'white', fontWeight: 'bold' }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 64 64"
                                            fill="none"
                                            stroke="#FFFFFF"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            aria-hidden="true"
                                        >
                                            <path d="M10 42c7-5 18-10 30-10 8 0 16 3 22 6v5c-5 2-12 4-20 4-6 0-10-1-14-3-5-3-9-6-15-7-3-1-5 1-7 2z" />
                                            <path d="M6 42c0-10 3-24 18-29 12-4 22 4 26 19" />
                                        </svg>
                                        {seccion.nomSeccion.toUpperCase()}
                                    </span>
                                    {hasNewCategories && (
                                        <span
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: 'white',
                                                padding: '2px 8px',
                                                borderRadius: '12px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                marginLeft: '10px'
                                            }}
                                        >
                                            NUEVO
                                        </span>
                                    )}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Row className="g-4">
                                    {seccion.categorias.map((categoria) => {
                                        const lastUpdated = new Date(categoria.lastUpdated);
                                        const threeDaysAgo = new Date();
                                        threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
                                        const isNew = lastUpdated >= threeDaysAgo;

                                        return (
                                            <Col key={categoria.idCategoria} xs={6} sm={4} md={3} className="d-flex justify-content-center">
                                                <Link
                                                    to={`/${idSucursal}/Productos/${categoria.nomCategoria}`}
                                                    className="text-decoration-none px-2"
                                                    onClick={() => handleCategoryClick(`panel${index}`)}
                                                >
                                                    <Card className="position-relative border-0 w-100 h-auto" style={{ borderRadius: '10px', overflow: 'hidden' }}>
                                                        <img
                                                            src={categoria.imgCategoria}
                                                            alt={categoria.nomCategoria}
                                                            className="w-100 img-categoria"
                                                            loading="lazy"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://via.placeholder.com/300x200';
                                                            }}
                                                        />
                                                        <div className="position-absolute top-0 w-100 py-1 px-3 text-light" style={{ background: 'rgba(0, 0, 0, 0.6)', fontWeight: 'bold', textAlign: 'center' }}>
                                                            {categoria.nomCategoria.toUpperCase()}
                                                            {isNew && (
                                                                <Badge bg='danger' className='ms-2'> Nuevo</Badge>
                                                            )}
                                                        </div>
                                                        <div className="position-absolute bottom-0 w-100 py-0 px-3 text-light" style={{ background: 'rgba(0, 0, 0, 0.6)', fontWeight: 'bold', textAlign: 'center', fontSize: "15px" }}>
                                                            {categoria.numProductos}
                                                        </div>
                                                    </Card>
                                                </Link>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </Container>
        </div>
    );
}

export default CategoriasUni;
